import { cn } from "@/lib/utils";
import LinkedText from "../linkedText/linkedText.component";

interface TwoColProps {
  // Intro paragraphs on the left. Support `[label](/route)` links and
  // `**bold**` (see LinkedText).
  paragraphs: string[];
  // The boxed checklist on the right.
  aside: { title: string; items: string[] };
  // The PageSection tone this sits on. On the tint band the box turns white
  // with a border so it doesn't vanish into the background.
  sectionTone?: "white" | "cream" | "tint";
}

// Prose beside a short boxed list (the preview's `.two` with `.prose` and
// `.aside`). Stacks on phones and tablets, side by side from `lg`.
const TwoCol = ({ paragraphs, aside, sectionTone = "white" }: TwoColProps) => (
  <div className="grid items-start gap-7 lg:grid-cols-[1.1fr_0.9fr] lg:gap-14">
    <div className="grid gap-3.5">
      {paragraphs.map((paragraph) => (
        <p
          key={paragraph}
          className="text-[17px] leading-relaxed text-ink-muted"
        >
          <LinkedText text={paragraph} />
        </p>
      ))}
    </div>
    <aside
      className={cn(
        "rounded-3xl p-6 sm:p-7",
        sectionTone === "tint" ? "border border-line bg-white" : "bg-paper",
      )}
    >
      <h3 className="text-[1.2rem] leading-snug font-bold tracking-[-0.01em]">
        {aside.title}
      </h3>
      <ul className="mt-3.5 grid gap-2.5">
        {aside.items.map((item) => (
          <li
            key={item}
            className="relative pl-[26px] text-[15.5px] leading-normal text-ink-muted before:absolute before:top-[7px] before:left-0 before:size-2.5 before:rounded-full before:bg-primary"
          >
            {item}
          </li>
        ))}
      </ul>
    </aside>
  </div>
);

export default TwoCol;
